'use client';

import { motion } from 'framer-motion';

export function HeadPage({ headingTitle }: { headingTitle: string }) {
  const text = headingTitle.split(' ');

  return (
    <section
      className='section-head-page bg-[url(/images/home/home-overlay.png)]
    bg-no-repeat bg-position-[center_center]'
    >
      <div
        className='inner max-w-[1120px] min-h-[50vh] md:min-h-[700px] px-[15px]
        mx-auto flex flex-col items-center gap-4 md:gap-8 pt-[30%] md:pt-[120px] lg:pt-[150px]'
      >
        <div className='text-center font-bold text-[1.5rem] md:text-[2.5rem] text-background'>
          <div className='whitespace-pre-line'>
            {text.map((el, i) => (
              <motion.span
                initial={{ opacity: 0 }}
                whileInView={{
                  opacity: 1,
                  x: 0, // Slide in to its original position
                  transition: {
                    duration: 0.8,
                    delay: i / 6, // Animation duration
                  },
                }}
                viewport={{ once: false }}
                key={i}
              >
                {el}{' '}
              </motion.span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
